// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__2eEcs","title":"style_title__NjJpa","editButtonWrapper":"style_editButtonWrapper__3no6U"};